import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
const ShadowLink = ({ to, children, ...props }) => {
    const navigate = useNavigate();
    const handleClick = (event) => {
        event.preventDefault(); // Prevent default anchor click behavior
        // Extract the invitation ID from the URL if present
        const urlParams = new URLSearchParams(window.location.search);
        const invitationId = urlParams.get('id'); // Get the 'id' parameter for the invitation
        console.log('Current URL:', window.location.href); // Debugging log
        console.log('Extracted invitation ID:', invitationId); // Debugging log
        if (invitationId) {
            // Save the ID to local storage
            localStorage.setItem('invitation_id', invitationId);
            console.log('Saved invitation ID to local storage:', invitationId); // Confirm saving
        }
        else {
            console.warn('No invitation ID found in the URL.'); // Warning log
        }
        // Redirect to the login module (adjust the path as needed)
        navigate('/signin'); // Change '/signin' to the correct route for your login module
    };
    return (_jsx("a", { href: to, onClick: handleClick, ...props, children: children }));
};
export default ShadowLink;
